<template>
  <div class="v-input" :class="{
    'v-input--is-focus': focusOn,
    'v-input--is-dirty': isDirty,
    'v-input--is-disabled': disabled,
    'v-input__error--border': !!errors.has(newName)
  }" data-vv-value-path="model" :data-vv-as="label">

    <label class="v-input__label" v-if="label">
      {{ label }}
    </label>

    <input class="v-input__field"
           v-model="model"
           :type="type || `text`"
           :min="min || false"
           :max="max || false"
           :maxlength="maxlength || false"
           :name="name"
           :disabled="disabled"
           :empty-model="clearField()"
           :id="id"
           :autocomplete="autocomplete"
           @focus="focusOn = true"
           @blur="blurMethod"
           @change="$emit('change', $event)"
           @keyup="$emit('keyup', $event)"
           ref="textField"
           v-if="id!==''">
    <input class="v-input__field"
           v-model="model"
           :type="type || `text`"
           :min="min || false"
           :max="max || false"
           :maxlength="maxlength || false"
           :name="name"
           :disabled="disabled"
           :empty-model="clearField()"
           :autocomplete="autocomplete"
           @focus="focusOn = true"
           @blur="blurMethod"
           @change="$emit('change', $event)"
           @keyup="$emit('keyup', $event)"
           ref="textField"
           v-else>

    <i v-if="inputIcon && isIconVisible()" class="v-input__icon"></i>

    <div class="v-input__error" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../mixins/field'

  export default {
    mixins: [field],
    props: {
      max: {
        default: null,
        type: String
      },
      min: {
        default: 0,
        type: Number
      },
      type: {
        default: null,
        type: String
      },
      emptyModel: {
        default: false,
        type: Boolean
      },
      inputIcon: {
        default: false,
        type: Boolean
      },
      inputIconCondition: {
        default: 0,
        type: Number
      },
      id: {
        default: '',
        type: String
      },
      isPrefillDisabled: {
        default: false,
        type: Boolean
      },
      isUpdateModel: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        focusOn: false,
        autocomplete: this.isPrefillDisabled ? 'off' : 'on'
      }
    },
    created() {
      if (this.isUpdateModel) {
        let that = this;
        this.$root.$on('updateModelWithCurrentValue', () => {
          console.log(that.value);
          that.model = that.value;
        });
      }
    },
    mounted() {
      if (this.isPrefillDisabled) {
        this.disableAutoComplete();
      }

      this.selectAllData();
    },
    methods: {
      blurMethod($event) {
        this.focusOn = false;
        this.$emit('blur', $event)
      },
      clearField: function () {
        if (this.emptyModel) {
          this.model = '';
          this.$emit('update:empty-model', false);
        }
      },
      isIconVisible() {
        return this.inputIcon && this.inputIconCondition && (Math.abs(parseFloat((this.model+'').replace(',','.'))) <= this.inputIconCondition) ? true : false;
      },
      disableAutoComplete() {
        let elements = document.querySelectorAll('[autocomplete="off"]');

        if (!elements) {
          return;
        }

        elements.forEach(element => {
          element.setAttribute('readonly', 'readonly');

          setTimeout(() => {
            element.removeAttribute('readonly');
          }, 500);
        });
      },
      selectAllData() {
        const selector = this.$refs.textField;

        selector.addEventListener("focus", function () {
          selector.select();
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/js/admin/components/VTextfield.vue